import React from 'react';
import { Redirect  } from 'react-router-dom';
import Cookies from 'js-cookie';

class PrivateRoute extends React.Component {
    render() {
        const { element } = this.props;
        // Try cookie first, then localStorage. Be defensive about missing values and JSON parsing.
        let accessToken = null;
        const cookieToken = Cookies.get('Token');
        if (cookieToken) {
            try {
                accessToken = JSON.parse(cookieToken);
            } catch (e) {
                accessToken = cookieToken;
            }
        }

        if (!accessToken) {
            const lsToken = localStorage.getItem('Token');
            if (lsToken) {
                try {
                    accessToken = JSON.parse(lsToken);
                } catch (e) {
                    accessToken = lsToken;
                }
            }
        }

        const isAuthenticated = !!accessToken;

        return isAuthenticated ? element : <Redirect to="/" replace />;
    }
}

export default PrivateRoute;
